import s, { forwardRef as c } from "react";
import { P as a } from "./index-CZzwT3Oj.mjs";
function l() {
  return l = Object.assign || function(e) {
    for (var n = 1; n < arguments.length; n++) {
      var r = arguments[n];
      for (var t in r)
        Object.prototype.hasOwnProperty.call(r, t) && (e[t] = r[t]);
    }
    return e;
  }, l.apply(this, arguments);
}
function v(e, n) {
  if (e == null) return {};
  var r = h(e, n), t, o;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (o = 0; o < i.length; o++)
      t = i[o], !(n.indexOf(t) >= 0) && Object.prototype.propertyIsEnumerable.call(e, t) && (r[t] = e[t]);
  }
  return r;
}
function h(e, n) {
  if (e == null) return {};
  var r = {}, t = Object.keys(e), o, i;
  for (i = 0; i < t.length; i++)
    o = t[i], !(n.indexOf(o) >= 0) && (r[o] = e[o]);
  return r;
}
var f = c(function(e, n) {
  var r = e.color, t = r === void 0 ? "currentColor" : r, o = e.size, i = o === void 0 ? 24 : o, p = v(e, ["color", "size"]);
  return /* @__PURE__ */ s.createElement("svg", l({
    ref: n,
    xmlns: "http://www.w3.org/2000/svg",
    width: i,
    height: i,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: t,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, p), /* @__PURE__ */ s.createElement("path", {
    d: "M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"
  }));
});
f.propTypes = {
  color: a.string,
  size: a.oneOfType([a.string, a.number])
};
f.displayName = "Facebook";
export {
  f as F
};
